import { destinationComponentIdByName } from "%/dynamic-component-editor/helpers/destination-component-by-name";

const ROW_TEMPLATES = {
  affiliateLink: { contextName: "affiliateLink", small: "Affiliate Link Card Small", large: "Affiliate Link Card Large" },
  communityPost: { contextName: "story", small: "Story Card", large: "Large Story Card" },
};

export function collectionRowTemplate(entityType, cardLayout, destinationId) {
  const template = ROW_TEMPLATES[entityType];
  if (!template) {
    return { componentId: 0, contextName: "" };
  }
  const size = cardLayout === "large" ? "large" : "small";
  return {
    componentId: destinationComponentIdByName(template[size], destinationId),
    contextName: template.contextName,
  };
}
